import { axiosClient } from '../axiosClient'

export interface LoginResponse {
  access_token: string
  token_type: string
}

export const authFunctions = {
  loginWithPassword: async (username: string, password: string): Promise<LoginResponse> => {
    const formData = new URLSearchParams()
    formData.append('username', username)
    formData.append('password', password)

    return await axiosClient.post('auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
  },
}
